module.exports = __webpack_public_path__ + "static/media/minus.1675af76.svg";